/** @jsxRuntime classic */
/** @jsx jsx */
/** @jsxFrag Fragment */
import { Col, Container, Label } from '@bottlebooks/gatsby-theme-base/src';
import ContentRow from '@bottlebooks/gatsby-theme-event/src/components/ContentRow';
import { Box } from '@mantine/core';
import { graphql } from 'gatsby';
import { Fragment } from 'react';
import { jsx } from 'theme-ui';
import FloorPlan, { FloorPlanData } from '../../../../components/_FloorPlan';

type Data = {
  name: string;
  registrationId: string;
  stand: null | {
    name: string;
    slug: string;
    room: null | {
      name: string;
      primaryColor: string;
      contrastColor: string;
      plan: undefined | null | FloorPlanData;
    };
  };
};

export const fragment = graphql`
  fragment ExhibitorFloorPlan on Bottlebooks_SingleRegistration {
    name
    registrationId
    stand {
      name
      slug
      room {
        name(locale: $locale)
        primaryColor
        contrastColor
        plan {
          ...FloorPlan
        }
      }
    }
  }
`;

export default function ExhibitorFloorPlan({ data }: { data: Data }) {
  const registration = data;
  const stand = data.stand;
  if (!stand?.name) return null;
  const room = data.stand?.room;
  const plan = room?.plan;
  const primaryColor = room?.primaryColor || undefined;
  const contrastColor = room?.contrastColor || undefined;
  const highlightedSlug = registration.stand?.slug;
  return (
    <>
      <Box bg={primaryColor} tt="uppercase" c={contrastColor} py="sm">
        <Container>
          <ContentRow>
            <Col>
              <Label variant="large">{stand?.name}</Label>
            </Col>
          </ContentRow>
        </Container>
      </Box>
      <div sx={{ backgroundColor: 'light', py: 2 }}>
        <Container>
          <FloorPlan
            data={plan}
            title={registration.name}
            id={registration.registrationId}
            primaryColor={primaryColor}
            contrastColor={contrastColor}
            highlightedSlug={highlightedSlug}
          />
        </Container>
      </div>
    </>
  );
}
